/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { qreq } from "../../shared/qrequest";
import { Link } from "react-router-dom";
import Icon from "../Icon";
import { Pop } from "../PopModal";
import { SidebarGlobal } from "../_Sidebar";

class RequestFormTypeList extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        };
        this.delete = this.delete.bind(this);
    }

    componentDidMount() {
        SidebarGlobal.setSubNav(<>
            <Link to="/form/type/new" className="btn btn-primary"><Icon icon="faPlus" /> <span className="d-none d-md-inline">New Form Type</span></Link>
        </>);

        qreq.get('/api/form/type/list', j => {
            if (j.list)
                this.setState({ list: j.list });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    delete(item) {
        if (Pop.showConfirm(<p>Are you sure you want to delete <strong>{item.name}</strong>?</p>, 'Delete Form Type', () => {
            qreq.post('/api/form/type/delete', item.id, j => {
                if (j.errorCode === 0) {
                    this.success('Form type deleted successfully.', 'success');
                    this.setState({ list: this.state.list.filter(i => i.id !== item.id) });
                } else {
                    this.alert(j.errorMessage);
                }
            }, this.unkownErrorCallback);
        }));
    }

    render() {
        return <div className="container-fluid">
            <h1>Request Form Templates</h1>
            {this.state.list ? <table className="table table-striped">
                <thead>
                    <tr>
                        <th style={{ width: '25px' }}></th>
                        <th style={{ width: '25px' }}></th>
                        <th>Name</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.list.map((item, i) => <tr key={i}>
                        <td><Link title="Edit" to={`/form/type/edit/${item.id}`}><Icon icon="faPencil" /></Link></td>
                        <td><span title="Delete" role="button" className="text-primary" onClick={() => this.delete(item)}><Icon icon="faTrash" /></span></td>
                        <td><Link title="Edit" to={`/form/type/edit/${item.id}`}>{item.name}</Link></td>
                    </tr>)}
                </tbody>
            </table> : <p className="fs-italic">No templates have been created.</p>}
        </div>;
    }
}

export default withParamsAndNavigate(RequestFormTypeList);